module.exports = __webpack_public_path__ + "img/thumbnail.60b097f5.jpg";